import { ComponentProps } from "react";
import { useNavigate } from "react-router";

import { CreateClientCard } from "@components/Cards/CreateClientCard/CreateClientCard";

import { routes } from "@pages/routes";

export const CreateClientManuallyPage = () => {
  const navigate = useNavigate();

  const onCreateClientSuccess: ComponentProps<
    typeof CreateClientCard
  >["onCreateClientSuccess"] = async (client) => {
    navigate(
      routes.portal.clients.client.dashboard.$buildPath({
        params: {
          clientId: client.id,
        },
      }),
      {
        viewTransition: true,
      },
    );
  };

  return <CreateClientCard onCreateClientSuccess={onCreateClientSuccess} />;
};
